module.exports = __webpack_public_path__ + "img/27.da502d54.png";